import { reducer as pronoReducer } from './prono.slice';

export default pronoReducer;
